import type { FC } from 'react';

import { Button, Row } from 'enable-ui';

import { isUndefined } from 'lodash';

export const ButtonAction: FC<{
  onCancel?: () => void;
  onSubmit?: () => void;
  disabledSubmit?: boolean;
  titleSubmit?: string;
  titleCancel?: string;
  disabledCancel?: boolean;
  style?: React.CSSProperties;
}> = ({ onCancel, onSubmit, disabledSubmit, titleSubmit, titleCancel, disabledCancel, style }) => {
  return (
    <Row
      align="center"
      style={{
        marginTop: 16,
        ...style,
      }}
    >
      <Button
        variant="outlined"
        type="submit"
        size="medium"
        style={{ marginRight: 12 }}
        onClick={onCancel}
        disabled={!isUndefined(disabledCancel) ? disabledCancel : true}
      >
        {titleCancel ?? 'Cancel changes'}
      </Button>
      <Button
        variant="contained"
        color="primary"
        type="submit"
        size="medium"
        onClick={onSubmit}
        disabled={!isUndefined(disabledSubmit) ? disabledSubmit : true}
      >
        {titleSubmit ?? 'Save'}
      </Button>
    </Row>
  );
};
